import {useEffect, useState} from "react";

const useImageLoadWatch = (initializeOn = [], options = {}) => {
  const [imagesLoadComplete, setLoadComplete] = useState(false);
  const [loadPercentage, setPercentage] = useState(0);

  const initialize = () => {
    const images = Array.from(document.images);
    let loadedImagesCount = 0;

    const promises = images.map(image => {
      return new Promise((resolve) => {
        if (image.complete) {
          resolve();
          loadedImagesCount++;
          setPercentage(parseInt(loadedImagesCount / images.length) * 100);
        } else {
          const onLoad = () => {
            resolve();
            loadedImagesCount++;
            setPercentage(parseInt(loadedImagesCount / images.length) * 100);

            image.removeEventListener("load", onLoad);
            image.removeEventListener("error", onLoad);
          };

          image.addEventListener("load", onLoad);
          image.addEventListener("error", onLoad);
        }
      });
    });

    Promise.all(promises).then(() => {
      setLoadComplete(true);
    });
  };

  useEffect(() => {
    if (options?.delay) setTimeout(() => requestAnimationFrame(initialize), options?.delay);
    else requestAnimationFrame(initialize);
  }, initializeOn);

  return {imagesLoadComplete, loadPercentage};
};

export default useImageLoadWatch;
